<template>
  <div class="teacher" id="teacher">
    <div class="teacher-box">
      <div class="tit">
        <h2 class="tit-live">顾问预约区</h2>
        <p>1v1快速对话教育顾问，定制个人专属求学方案</p>
      </div>

      <div class="con">
        <h3>
          快速预约
          <span>{{curCity}}</span> 分公司顾问
        </h3>
        <span class="btn btn1" v-if="adviserStatus<=2 && status == 2" @click="appointment">马上预约</span>
        <span class="btn btn2" v-else-if="adviserStatus<=2 && status == 1" @click="isShow2=true">预约成功</span>
        <span class="btn btn3" v-else-if="adviserStatus>2">预约结束</span>
        <div class="con-disc">
          <h5 class="con-title">提供哪些咨询服务:</h5>
          <ul>
            <li>
              <i></i>背景评估与学习方案制定
            </li>
            <li>
              <i></i>学校专业选择与职业规划
            </li>
            <li>
              <i></i>语言能力提升与学术技能培养
            </li>
            <li>
              <i></i>文书创意与写作指导
            </li>
          </ul>
        </div>

        <!-- <span class="more" @click="manualSelectItem()">更多顾问详情 ></span> -->
      </div>
    </div>

    <!-- 预约成功 -->
    <div class="tc-bg" v-if="isShow">
      <div class="tc">
        <img class="qycj_succ_dh" src="@/assets/images/teacher_tc_dh.png" />
        <h4>您已成功预约</h4>
        <h6>
          您已成功预约顾问咨询服务，
          <br />我们的工作人员将尽快与您取得联系，请保持电话畅通。
        </h6>
        <a @click="close" class="btn-qd">确定</a>
      </div>
    </div>

    <!-- 预约成功 -->
    <div class="tc-bg" v-if="isShow2">
      <div class="tc">
        <img class="qycj_succ_dh" src="@/assets/images/teacher_tc_ts.png" />
        <h4>请勿重复预约</h4>
        <h6>
          您已经成功预约了一个顾问咨询服务，
          <br />不能重复预约，祝您咨询愉快。
        </h6>
        <a @click="close" class="btn-qd">确定</a>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { adviserSubscribe, checkAdviserSubscribe } from "@/api/home";
export default {
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    curCity: {
      type: String,
      default: "",
    },
    // 顾问预约时间状态
    adviserStatus: {
      type: Number,
    },
    expoId: {
      type: Number,
      default: 0,
    },
    partStartTime: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  data() {
    return {
      isShow: false,
      isShow2: false,
      status: 0,
      startTime: "", //时间戳转为日月时分
    };
  },
  computed: {},
  methods: {
    // 点击提交按钮
    async appointment() {
      // 判断是否登录
      if (!this.isLogin) {
        this.$emit("showLogin", "teacher");
        return;
      }

      if (this.adviserStatus == 1) {
        setTimeout(() => {
          alert(this.startTime + "正式开始预约~~");
        }, 500);
        return;
      }

      if (this.adviserStatus == 3) {
        alert("活动已结束");
        return;
      }
      this.checkAdviserSubscribe();

      if (this.adviserStatus == 2) {
        // 提交数据
        let res = await adviserSubscribe({
          expoId: this.expoId,
          typeId: 1,
        });
        if (res.succ) {
          this.isShow = true;
          this.status = 1; //已经预约
        } else {
          this.isShow2 = true;
        }
      }
    },

    // 点击关闭弹窗
    close() {
      this.isShow = false;
      this.isShow2 = false;
    },

    // 判断用户是否预约
    async checkAdviserSubscribe() {
      let res = await checkAdviserSubscribe({
        expoId: this.expoId,
        typeId: 1,
      });
      console.log(res);
      if (res.succ) {
        this.status = 1; //已经预约
      } else {
        this.status = 2; //未预约
      }
    },

    // 点击跳转手动预约顾问
    manualSelectItem() {
      this.$router.push({
        name: "teacherList",
        // query: { type: val, curCity: this.curCity },
      });
    },
  },

  created() {},
  watch: {
    expoId() {
      this.checkAdviserSubscribe();
      this.startTime = moment(parseInt(this.partStartTime * 1000)).format(
        "M[月]D[日]H:mm"
      );
    },
  },
};
</script>

<style lang="less" scoped>
.teacher {
  padding: 0.2rem 0.3rem 0.5rem;
  .teacher-box {
    background-color: #4089ea;
    border-radius: 0.24rem;
    padding: 0 0.1rem 0.2rem;
    // border: 0.03rem solid #1f1f1f;
    // 标题
    .tit {
      color: #fff;
      padding: 0.3rem 0 0.3rem 0.3rem;
      h2 {
        font-size: 0.5rem;
        font-weight: 900;
      }
      p {
        font-size: 0.26rem;
        padding-top: 0.1rem;
      }
    }
    .con {
      border-radius: 0.2rem;
      background-color: #fff;
      position: relative;
      h3 {
        font-size: 0.32rem;
        color: #2542c9;
        text-align: center;
        padding-top: 0.3rem;
        span {
          font-weight: 900;
        }
      }
      .btn {
        display: block;
        width: 2.4rem;
        height: 0.65rem;
        line-height: 0.65rem;
        font-size: 0.28rem;
        font-weight: 900;
        margin: 0.4rem auto;
        text-align: center;
        border-radius: 10rem;
        //box-shadow: 0 0.05rem 0 #2541C9;
        //border: 0.03rem solid #1f1f1f;
        border: 0;
        color: #fff;
        &.btn1 {
          background-color: #ff5156;
          //color: #222222;
          //box-shadow: 0 0.05rem 0 #ff5156;
        }
        &.btn2 {
          background-color: #0358dd;
          //box-shadow: 0 0.05rem 0 #0358dd;
        }
        &.btn3 {
          background-color: #bababa;
          //box-shadow: 0 0.05rem 0 #bababa;
        }
      }

      .con-disc {
        border-top: 0.02rem solid #b9cdf8;
        background-color: #f6f9ff;
        padding: 0.13rem 0.2rem 0.26rem 0.2rem;
        border-radius: 0 0 0.2rem 0.2rem;
      }
      h5 {
        height: 0.22rem;
        font-size: 0.22rem;
        font-family: SourceHanSansCN;
        font-weight: 400;
        color: #2542c9;
        line-height: 0.28rem;
        margin-bottom: 0.2rem;
      }
      ul {
        li {
          display: inline-block;
          width: 50%;
          vertical-align: top;
          font-size: 0.2rem;
          color: #656565;
          i {
            display: inline-block;
            width: 0.16rem;
            height: 0.16rem;
            background-color: #2542c9;
            border-radius: 50%;
            margin-right: 0.1rem;
          }
        }
      }
      .more {
        position: absolute;
        right: 0.22rem;
        bottom: 0.22rem;
        font-size: 0.22rem;
        color: #ff6368;
      }
    }
  }
}

.prize .tc-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
}

.teacher .tc {
  width: 6.2rem;
  height: 3.58rem;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  padding: 0.1rem 0.3rem 0;
  border-radius: 0.2rem;
  text-align: center;
  border: 0.02rem solid #2d66e8;
}
.teacher .tc .close {
  width: 0.32rem;
  height: 0.28rem;
  position: absolute;
  right: 0;
  top: 0;
}

.teacher .tc .qycj_succ_dh {
  width: 0.78rem;
  height: 0.78rem;
  display: block;
  margin: 0.2rem auto 0.24rem;
}
.teacher .tc h4 {
  font-size: 0.3rem;
  font-weight: 900;
  color: #0475df;
}
.teacher .tc h6 {
  font-size: 0.22rem;
  padding: 0.1rem 0 0.3rem;
}
.teacher .tc p {
  font-size: 0.3rem;
  padding-top: 0.1rem;
  color: #0475df;
}
.teacher .tc .btn-qd {
  width: 1.6rem;
  height: 0.44rem;
  display: block;
  margin: 0 auto;
  background: #0475df;
  color: #fff;
  font-size: 0.24rem;
  text-align: center;
  line-height: 0.44rem;
  border-radius: 0.22rem;
}
.teacher .tc .btn-box {
  font-size: 0;
  text-align: center;
  padding-top: 0.4rem;
}
.teacher .tc .btn-box li {
  width: 1.3rem;
  height: 0.5rem;
  display: inline-block;
  background: #0475df;
  color: #fff;
  text-align: center;
  margin-right: 0.34rem;
  font-size: 0.25rem;
  line-height: 0.5rem;
  border-radius: 0.25rem;
}
.teacher .tc .btn-box li:nth-child(2) {
  background: #ee355d;
}
.teacher .tc .btn-box li:nth-child(3) {
  margin-right: 0;
  background: #57b42f;
}
</style>